
export default {
    name: 'LeeToolTip',
    inheritAttrs: false,
    data() {
        return {
            isshow:false
        }
    },
    computed: {
        positionStyle() {
            if (this.position === 'left') {
                return 'left'
            } else if (this.position === 'right') {
                return 'right'

            } else if (this.position === 'bottom') {
                return 'bottom'

            } else {
                return 'top'
            }

        },
        transitionCss(){
            return 'left'
        }

    },
    methods: {
        enter() {
            this.isshow = true;
        },
        leave() {
            this.isshow = false;
        }
    },
    props: {
        color: {
            type: String,
            default: '#333' //默认default
        },
        content: {
            type: String,
            default: '' //默认default
        },
        position: {
            type: String,
            default: 'top' //默认default
        }
    }
};
